export default "__VITE_ASSET__Be8799xx__"